export default "__VITE_ASSET__Bn59sp1X__"